import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiService } from './api.service';

@Injectable()
export class EncountersService extends ApiService {
  private http = inject(HttpClient);

  getEncounterTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.captureApi.url}/encounters/encounter_types`);
  }
}
